export enum CustomerType {
    NotValidated = 'NotValidated',
    PrepaidNoDiscount = 'PrepaidNoDiscount',
    PrepaidWithDiscount = 'PrepaidWithDiscount',
    NoPrepaidWithDiscount = 'NoPrepaidWithDiscount',
}
